const cancel = 'Abbrechen'
const save = 'Speichern'

export default {

  global: {
    generalError: 'Hoppla! Die Anfrage konnte nicht verarbeitet werden. Bitte aktualisieren Sie die Seite.',
    signature: 'Mit freundlichen Grüßen,',
  },

  component: {
    actionBar: {
      actions: 'Aktionen',
      hideActions: 'Aktionen ausblenden',
    },

    addButton: {
      add: 'Hinzufügen',
    },

    attachments: {
      add: 'CV oder weitere Anhänge hinzufügen',
      placeholderWithDescription: 'Fügen Sie die angeforderten Anhänge hinzu',
      remove: 'Entfernen',
      allowedFileTypes: 'Zulässige Dateitypen',
      errors: {
        size: 'Datei ist zu groß, maximale Dateigröße beträgt 5MB.',
        empty: 'Datei enthält keine Daten',
        invalidType: fileType => `Sorry, ${fileType}-Dateien sind aus Sicherheitsgründen nicht erlaubt`,
        typeNotWhitelisted: 'Leider ist der Dateityp nicht zulässig.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Datenschutzbestimmungen',
      termsLinkText: 'allgemeinen Geschäftsbedingungen',
      privacyPolicyText: 'Wir respektieren Ihre Privatsphäre, bitte lesen Sie unsere ',
      termsText1: 'Lesen und akzeptieren Sie die ',
      termsText2:
        'bevor Sie uns Ihre personenbezogenen Daten zur Verfügung stellen.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Wenn Du nicht möchtest, dass wir Deine personenbezogenen Daten verarbeiten, kannst du deren Löschung per Nachricht an ${mail} beantragen.`,
      customSupportPrivacyInfo: link => `Wenn Sie nicht wollen, dass wir Ihre personenbezogenen Daten verarbeiten, können Sie sich an ${link} wenden, um deren Lösung zu beantragen.`,
    },

    buttons: {
      close: 'Schließen',
    },

    competencies: {
      addCompetency: 'Neue Kompetenz hinzufügen',
      edit: 'Kompetenzen bearbeiten',
      done: 'Fertig',
      defaultsDescription: 'Wenn Sie nicht sicher sind, welche Kompetenzen Sie verwenden sollen, haben wir zur Unterstützung einige gute Standardkompetenzen festgelegt',
      getDefaults: 'Standardkompetenzen einsehen',
    },

    competency: {
      warning: 'Kompetenz und all deren Bewertungen entfernen?',
    },

    confirmDelete: {
      delete: 'Löschen',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
    },

    confirm: {
      cancel: 'Aufnahme entfernen',
      confirm: 'Erneut versuchen',
    },

    confirmButton: {
      wait: count => `Warte ${count}`,
      confirm: 'Bestätigen',
    },

    controlStatus: {
      text: {
        empty: 'Eingeben',
        valid: () => 'Bereit',
      },
      textarea: {
        empty: 'Eingeben',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Festlegen',
        valid: () => 'Bereit',
      },
      file: {
        empty: 'Auswählen',
        valid: () => 'Ändern',
      },
      list: {
        empty: 'Hinzufügen',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Suchen',
        valid: () => 'Bereit',
      },
    },

    cookieConsentModal: {
      title: 'Unsere Website verwendet Cookies',
      body: 'Indem Sie alle Cookies akzeptieren, stimmen Sie der Speicherung von Cookies auf Ihrem Gerät zu, um die Navigation auf der Website zu verbessern, die Nutzung der Website zu analysieren und unsere Marketingbemühungen zu unterstützen.',
      learnMoreLinkText: 'Erfahren Sie mehr darüber, wie wir Cookies verwenden',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Cookies verwalten',
      acceptAll: 'Alle Cookies akzeptieren',
      manageTitle: 'Zustimmungseinstellungen verwalten',
      necessaryCookiesTitle: 'Notwendige Cookies',
      necessaryCookiesBody:
        'Diese Cookies sind für das Funktionieren der Website erforderlich und können nicht in unseren Systemen abgeschaltet werden.',
      performanceCookiesTitle: 'Performance-Cookies',
      performanceCookiesBody:
        'Mit diesen Cookies können wir Besuche und Zugriffsquellen zählen, damit wir die Performance unserer Website messen und verbessern können.',
      confirmChoices: 'Meine Auswahl bestätigen',
      marketingCookiesTitle: 'Marketing-Cookies',
      marketingCookiesBody:
        'Diese Cookies ermöglichen es uns, Werbung zu personalisieren und ihre Werbeleistung zu messen.',
      functionalCookiesTitle: 'Funktionsbezogene Cookies',
      functionalCookiesBody:
        'Diese Cookies werden verwendet, um die Funktion der Website zu verbessern. Ohne diese Cookies sind bestimmte Funktionen möglicherweise nicht mehr verfügbar. Beispiele für funktionsbezogene Cookies sind Web-Chat-Dienste und Benutzereinstellungen.',
    },

    emailAddresses: {
      remove: 'Entfernen',
      importCsv: 'Import CSV',
      invalidEmails: 'Ungültige E-Mails gefunden.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'Die CSV-Zeilen können entweder eine E-Mail-Adresse oder sowohl eine E-Mail-Adresse als auch eine Telefonnummer enthalten. Jede Zeile steht für einen Empfänger. Telefonnummern müssen im internationalen Format (E.164) angegeben werden, z. B. <strong>+358</strong>50xxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-Mail wurde zurückgesendet. Stellen Sie sicher, dass der Empfänger Ihre Nachricht erhalten hat.',
      },
      Permanent: {
        General: 'E-Mail-Zustellung fehlgeschlagen. Der E-Mail-Anbieter des Empfängers hat die Nachricht abgelehnt.',
        NoEmail: 'Diese E-Mail-Adresse existiert nicht.',
        Suppressed: 'Die E-Mail konnte aufgrund vorheriger erfolgloser Zustellversuche nicht zugestellt werden.',
      },
      Transient: {
        General: 'E-Mail wurde zurückgesendet. Stellen Sie sicher, dass der Empfänger Ihre Nachricht erhalten hat.',
        MailboxFull: 'Das Postfach des Empfängers ist voll',
        MessageTooLarge: 'Der Inhalt der Nachricht ist zu groß.',
        ContentRejected: 'Der Inhalt der Nachricht wurde abgelehnt.',
        AttachmentRejected: 'Der Anhang wurde abgelehnt.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'Die angegebene Nummer wurde bereits zu einem Kandidaten im Vorstellungsgespräch hinzugefügt.',
    },

    error403: {
      heading: 'Zugriff gesperrt',
      content: 'Bitte stellen Sie sicher, dass Sie mit dem richtigen Konto angemeldet sind und eingeladen wurden, sich diese Position in Recright anzusehen. Stellen Sie außerdem sicher, dass Sie Recright nur in einem einzigen Browserfenster verwenden.',
      link: 'Startseite',
    },

    error404: {
      heading: 'Nichts vorhanden',
      content: 'Wir haben überall nachgesehen, aber es gibt keine Webseite unter der von Dir angefragten Adresse. Vielleicht bist du einem abgelaufenen Link gefolgt oder hast versehentlich die falsche Adresse eingegeben.',
      link: 'Startseite',
    },

    error410: {
      heading: 'Geschlossen',
      content: 'Der Job kann nicht angezeigt werden, da er entweder geschlossen ist oder der Bewerbungszeitraum abgelaufen ist.',
      link: 'Startseite',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Wird initialisiert...',
      connection_error_hint: 'Es konnte keine Netzwerkverbindung hergestellt werden.\nVersuche, die Seite neu zu laden.',
      permission_hint: 'Du musst dieser Seite gestatten, Deine Webcam und Dein Mikrofon zu verwenden.',
      searching_camera_hint: 'Suche nach einer Webcam...',
      camera_reserved_hint: 'Eine andere Anwendung oder Webseite hat Deine Webcam reserviert.\nBitte schließe diese Anwendung und lade diese Seite neu.',
      camera_reserved_hint_chrome_extra: '\n\nLieber Chrome-Nutzer, Du musst Recright über den Dialog unter der Adressleiste die Benutzung der Webcam gestatten.',
      no_camera_hint: 'Webcam konnte nicht gefunden werden.',
      no_mic_hint: 'Mikrofon konnte nicht gefunden werden.',
      uploading_text: 'Wird hochgeladen...',
      rtmpt_in_use: 'Dieser Schritt wäre nicht nötig, wenn Dein Netzwerk\nAdministrator RTMP erlauben würde. Frage uns, wie.',
      preview_text: 'Die Webcam ist im Vorschau-Modus',
      close_text: 'Kamera schließen',
      remove_text: 'Aufnahme entfernen',
      noflash_errortext_install: link => `Anscheinend hast du nicht den Adobe Flash Player. Du benötigst ein Flash-Plugin, um Videos aufzunehmen. Lade Flash hier herunter: ${link}`,
      noflash_errortext_enable: link => `Falls Du Flash bereits installiert hast, aber weiterhin diese Nachricht siehst: Schau hier nach: ${link}`,
      noflash_errortext_differentbrowser: 'Alternativ kannst Du einen Browser ausprobieren, der HTML5-Aufnahme unterstützt. Wir empfehlen Chrome oder Firefox.',
    },

    footer: {
      terms: 'Nutzungsbedingungen von Recright',
      license: 'Allgemeinen Geschäftsbedingungen von Recright',
      privacyPolicy: 'Datenschutzrichtlinien',
      customSupport: link => `Kontakt ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Wie würden Sie Ihre Interview-Erfahrung bewerten?',
      howWouldYouRateJobAd: 'Wie würden Sie Ihre Bewerbungserfahrung bewerten?',
      yourResponseIsAnonymous: 'Ihre Antwort ist anonym.',
      thankYouFeedback: 'Vielen Dank für Ihr Feedback',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Leider ist der Dateityp nicht zulässig.',
      isRequired: 'Dies ist ein Pflichtfeld.',
      isEmail: value => `${value} ist keine gültige E-Mail-Adresse.`,
      isDate: value => `${value} ist kein gültiges Datum.`,
      invalidUrl: 'URL ist ungültig.',
      singleHireEndError: 'Einzelne Einstellung kann nicht länger als 60 Tage verwendet werden.',
      isNotTooOldForLive: 'Datum liegt in der Vergangenheit.',
      isNotAfterEndDate: 'Das ausgewählte Datum kann nicht nach dem Schlussdatum des Stellenangebots liegen.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Die Telefonnummer wurde bereits hinzugefügt.',
      duplicateCompetency: 'Eine Kompetenz mit diesem Namen existiert bereits',
      isNotDuplicateTemplateName:
        'E-Mail-Vorlage mit diesem Namen existiert bereits.',
    },

    jobAdApplication: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      city: 'Stadt',
      applyForPosition: 'Auf Stelle bewerben',
      back: 'Zurück',
      continue: 'Weiter',
      submit: 'Absenden',
      saveForLater: 'Später fortfahren',
      namePlaceholder: 'Gib Deinen Namen ein',
      emailPlaceholder: 'Gib Deine E-Mail-Adresse ein',
      phonePlaceholder: 'Gib Deine Telefonnummer ein',
      cityPlaceholder: 'Gib Deinen aktuellen Wohnort ein',
      links: 'Füge Links hinzu, z. B. zu Deinem LinkedIn-Profil.',
      legendLinks: 'Links',
      legendAttachments: 'Anhänge',
      legendAdditionalFields: 'Zusätzliche Informationen',
      legendBasicInfo: 'Allgemeine Informationen',
      coverLetter: 'Bewerbungsschreiben',
      attachments: 'Anhänge',
      introduction: 'Verfasse hier Deine Kurzvorstellung',
      thankYou: 'Vielen Dank.',
      luck: 'Viel Glück!',
      close: 'Schließen',
      required: 'Mit einem * Stern gekennzeichnete Felder sind Pflichtfelder.',
    },

    jobAdContainer: {
      endTime: date => (date ? `offen bis ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Auf Stelle bewerben',
    },

    jobAdQuickInterview: {
      back: 'Zurück',
      submit: 'Absenden',
      saveForLater: 'Später fortfahren',
      title: 'Kurzes Video-Interview',
      description: 'Um Dich schneller kennenzulernen, möchten wir Dich bitten, kurz auf unsere Interviewfrage zu antworten. Bringe Deine Persönlichkeit zur Geltung und verleihe Deiner Bewerbung eine Seele.',
      requiredNote: 'Bitte beachte, dass dies ein Teil des Bewerbungsverfahrens ist und der Personalverantwortliche deine Bewerbung erst erhält, nachdem du Deine Antwort aufgezeichnet hast.',
      reminderNote: 'Du kannst die Antwort sofort aufnehmen oder später fortfahren, indem Du Dir eine Erinnerung per E-Mail senden lässt.',
    },

    jobAdRow: {
      responses: 'Bewerbungen',
      status: {
        open: 'Offen',
        filled: 'Besetzt',
        cancelled: 'Abgebrochen',
        done: 'Fertig',
        close: 'Schließen',
        draft: 'Geschlossen (Entwurf)',
        hidden: 'Verborgen',
      },
    },

    interviewRow: {
      responses: 'Kandidaten',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'LinkedIn-Profil anzeigen',
    },

    linkedInButton: {
      error: 'Beim Abrufen des Profils ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal.',
      buttonText: 'Über LinkedIn bewerben',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Sie können Ihr LinkedIn-Profil verwenden, um das Bewerbungsformular im Voraus auszufüllen',
      linkedInOr: 'Oder',
      error: 'Beim Abrufen des Profils ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal.',
    },

    linkListInput: {
      addField: 'Hinzufügen',
      removeField: 'Entfernen',
      invalidUrl: 'URL ist ungültig.',
    },

    loadingButton: {
      loading: 'Wird geladen...',
      saving: 'Wird gespeichert...',
      sending: 'Wird gesendet...',
    },

    modalApplicationForm: {
      applyForPosition: 'Auf Stelle bewerben',
      continue: 'Fortfahren',
      name: 'Gib Deinen Namen ein',
      email: 'Gib Deine E-Mail-Adresse ein',
      phoneNumber: 'Gib Deine Telefonnummer ein',
      links: 'Du kannst Links eingeben',
      legendLinks: 'Links',
      legendAttachments: 'Anhänge',
      coverLetter: 'Bewerbungsschreiben',
      attachments: 'Anhänge',
      introduction: 'Verfasse hier Deine Vorstellung',
      thankYou: 'Vielen Dank.',
      luck: 'Viel Glück!',
      close: 'Schließen',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Teilbarer öffentlicher Link',
      info: 'Hier ist die öffentliche Adresse einer Stellenanzeige, die du teilen kannst.\nJeder, der sich für die Stelle interessiert, kann die Stelle sehen \nund dann entscheiden, ob er/sie sich bewerben will.\nDu erhältst die übliche Benachrichtigung, sobald die ersten Bewerbungen eingehen.\n\nHier ist ein öffentlicher Link zu der Stellenanzeige:',
    },

    modalVideoAdd: {
      title: 'Neues Video hinzufügen',
      chooseTitle: 'Neues Video hinzufügen',
      titlePlaceholder: 'Video-Titel hier eingeben',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Neues Video hochladen',
      info: 'Die maximal zulässige Videogröße beträgt 500 MB. Wir empfehlen, dass die Videos vor dem Hochladen komprimiert werden, da das Hochladen und die Konvertierung so weniger Zeit beanspruchen.',
    },

    modalCandidateInfo: [
      {
        headline: 'Nimm Deine Video-Antwort auf ',
        content: 'so oft wie Du möchtest. Videos werden sofort nach dem Aufzeichnen gespeichert, und Du kannst über den Link, den Du per E-Mail erhalten hast, zum Video-Interview zurückkehren.',
        mobileContent: 'so oft wie Du möchtest. Füge das Video dem Interview hinzu. Das Video wird dann hochgeladen und im Interview gespeichert. Über den Link in der E-Mail kannst Du zum Video-interview zurückkehren. <br><br><strong>Wenn Sie ein Mobilgerät von Apple verwenden und der Videobildschirm schwarz bleibt, <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">finden Sie hier Anweisungen zur Problembehebung</a>.</strong>',
      },
      {
        headline: 'Nach der Aufnahme, ',
        content: 'vergewissere dich, dass das Video korrekt abgespielt wird und Deine Stimme hörbar ist. Wenn Du die Schaltfläche "Senden" betätigst, wird Deine Antwort endgültig, und Du kannst sie nicht mehr bearbeiten.',
      },
      {
        headline: 'Wenn du mit dem Interview fertig bist, ',
        content: 'Betätige die Schaltfläche "Antworten senden und Interview abschließen". Daraufhin kannst Du nicht zum Video-Interview zurückkehren. Falls Du diese Seite schließen, aber später mit dem Interview fortfahren möchtest, betätige die Schaltfläche "Später fortsetzen".',
      },
      {
        headline: 'Falls Du Hilfe benötigst, ',
        content: mailto => `um auf das Video-Interview zu antworten, klicke auf die Schaltfläche "Hilfe" unten rechts auf der Seite oder sende uns eine E-Mail an ${mailto}.`,
        customContent: link => `Kontakt ${link}`,
      },
    ],

    navigationBar: {
      back: 'Zurück',
      dashboard: 'Dashboard',
      frontpage: 'Startseite',
    },

    personDetails: {
      stage: 'Phase',
      namePlaceholder: 'Kandidat',
      contact: 'Kontakt',
      links: 'Links',
      attachments: 'Anhänge',
      coverLetter: 'Anschreiben',
      referrer: 'Ursprung',
      referrerInfo: 'Die Webseite, von der der Kandidat zu dem Service kam.',
      noStage: 'Noch in keiner Phase',
      headerAdditionalInformation: 'Zusätzliche Informationen',
      lastSeen: time => `Zuletzt gesehen ${time}.`,
      notVisited: 'Hat das Interview nicht besucht.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also gefunden auf ${count} anderen Positionen`,
      state: {
        invited: 'Eingeladen',
        visited: 'Aufgerufen',
        incomplete: 'Unvollständig',
        completed: 'Abgeschlossen',
      },
    },

    phoneInput: {
      placeholder: example => `Telefon im Format ${example}`,
    },

    rating: {
      ownVote: 'Deine Bewertung',
      yourRating: rating => `Deine Bewertung: ${rating}`,
      yourVotePlaceholder: 'Sie haben noch nicht abgestimmt.',
      totalVotes: count => `Insgesamt ${count} Bewertungen`,
      mobileModalHeader: 'Fügen Sie Ihre Bewertung hinzu',
      noRatings: 'Noch keine Bewertungen',
      yourRatingReset: 'Ihre Abstimmung zurücksetzen',
      averageRating: 'Durchschnittliche Bewertung',
      reset: 'zurücksetzen',
    },

    questionsAndResponses: {
      response: 'Antwort',
      noResponse: 'Keine Antwort',
      resetQuestionResponse: 'Kandidatenantwort löschen',
      resetQuestionResponseConfirm: questionTitle =>
        `Sind Sie sicher, dass Sie die Frage "${questionTitle}" für den Kandidaten zurücksetzen und seine Antwort löschen wollen?`,
      resetQuestionResponseConfirm2:
        'Falls ja, kann der Kandidat diese Frage erneut beantworten.',
    },

    share: {
      share: 'Teilen auf',
      copy: 'Link kopieren',
    },

    sort: {
      sort: 'Sortieren',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Ausgewählt',
      change: 'Änderung',
    },

    video: {
      videoNotFound: 'Video wird verarbeitet oder wurde nicht gefunden',
      retry: 'Erneut versuchen',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Datei auswähl' : 'Datei auswählen'),
      videoPlaceholder: 'Nimm Deine Antwort auf',
      uploadPlaceholderCandidate: 'Laden Sie Ihre Antwort',
      submit: 'Antwort absenden',
      notAnswered: 'Noch nicht beantwortet',
      remove: 'Aufnahme entfernen',
      converting: 'Video wird konvertiert. Bitte warten...',
      uploading: 'Video wird hochgeladen. Bitte warten...',
      error: {
        invalid: 'Ausgewählte Datei ist zu groß. Bitte wähle eine andere Datei aus.',
        upload: 'Entschuldigung, wir konnten das Video leider nicht hochladen. Bitte versuche es erneut.',
        transcode: 'Die ausgewählte Videodatei war beschädigt oder ungültig. Bitte versuche es erneut.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Mehr anzeigen',
      showLessButtonText: 'Weniger anzeigen',
      infoText1:
        'Halten Sie den Tab während der Aufzeichnung im Vordergrund aktiv. Sie sollten während der Aufzeichnung keine andere Anwendung verwenden.',
      infoText2:
        'Video-Hintergrundvideos funktionieren am besten mit den neuesten Browsern und mit einem Gerät, das relativ neu und leistungsstark ist.',
      infoText3:
        'Stellen Sie sicher, dass andere Anwendungen Ihr Mikrofon oder Ihre Kamera nicht benutzen.',
    },

    webcam: {
      useVideoBgButtonText: 'Videohintergrund verwenden',
      removeVideoBgButtonText: 'Videohintergrund entfernen',
      starting: 'Wird gestartet...',
      close: 'Kamera schließen',
      remove: 'Aufnahme entfernen',
      record: 'Aufnehmen',
      stop: 'Anhalten',
      retake: 'Erneut aufnehmen',
      submit: 'Antwort absenden',
      converting: 'Video wird konvertiert. Bitte warten...',
      uploading: 'Video wird hochgeladen. Bitte warten...',
      downloading: 'Video wird heruntergeladen. Bitte warten...',
      processing: 'Wird verarbeitet...',
      uploadInProgress: 'Die Übertragung des Videos ist noch im Gange. Bitte nicht den Browser schließen oder die Seite verlassen.',
      uploaded: 'Video übertragen.',
      error: {
        DevicesNotFoundError: 'Kamera oder Mikrofon können nicht verwendet werden. Bitte vergewissere Dich, dass sie aktiviert sind.',
        NotFoundError: 'Kamera oder Mikrofon können nicht verwendet werden. Bitte vergewissere Dich, dass sie aktiviert sind.',
        NotAllowedError: 'Du hast keine Berechtigung zum Benutzen der Kamera oder des Mikrofons gegeben.',
        PermissionDismissedError: 'Du hast den Berechtigungs-Dialog geschlossen. Bitte erteile die Berechtigung zum Benutzen der Kamera und des Mikrofons.',
        PermissionDeniedError: 'Du hast den Zugriff auf Kamera oder Mikrofon verweigert.',
        NotReadableError: 'Lesen des Kamera- oder Mikrofon-Streams nicht möglich. Mögliches Hardware-Problem.',
        SecurityError: 'Kamera oder Mikrofon kann aufgrund eines Sicherheitsfehlers nicht verwendet werden',
        stream: 'Ein Fehler ist aufgetreten. Bitte starte deinen Browser neu.',
        download: 'Video-Download fehlgeschlagen. Erneut versuchen?',
        upload: 'Video-Upload fehlgeschlagen. Erneut versuchen?',
        emptyBlob: 'Der Speicher deines Browsers oder Geräts ist voll und die Aufzeichnung kann nicht erstellt werden. Bitte lade die Seite neu und falls das nicht hilft, starte den Browser neu. Sollte das Problem weiterhin bestehen, versuche es mit einem anderen Browser.',
        alternativeRecorder: 'Sie können auch eine Datei hochladen, indem Sie hier klicken.',
        reconnecting: 'Die Verbindung wurde unterbrochen. Ich versuche, mich wieder zu verbinden.',
      },
    },

    videoResponse: {
      videoPlaceholder: 'Nimm Deine Antwort auf',
      uploadPlaceholder: 'Laden Sie Ihre Antwort',
      submit: 'Antwort absenden',
      notAnswered: 'Noch nicht beantwortet',
      startInterview: 'Interview beginnen',
    },

    smsMessages: {
      invitationMessage: title =>
        `Hi! Wir möchten Sie zu einem Video-Interview einladen ${title}! Diese Einladung wurde auch an Ihre E-Mail geschickt. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'Dies ist eine Vorschau auf das Interview. Die Videoaufzeichnung ist deaktiviert und die Formulardaten werden nicht gespeichert.',
    },
  },
}
